import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import Button from '4all-ui/components/Button';
import Input from '4all-ui/components/Input';
import Select from '4all-ui/components/Select';
import * as styles from './style';
import { getParentElement } from '../../helpers/modal';
import { TIMER } from '../../helpers/constants';
import Formats from '../../helpers/formats';
import DeliveryIcon from '../Icons/Delivery';
import TakeawayIcon from '../Icons/Takeaway';
import AlertIcon from '../Icons/Alert';

const TimeModal = ({ onClose, onSave, show, data, merchantIsUpdating, error }) => {
  const [form, setForm] = useState({
    deliveryEstimatedTime: '',
    takeAwayEstimatedTime: '',
    deliveryEstimatedIdUnitTime: '',
    takeAwayEstimatedIdUnitTime: '',
  });

  useEffect(() => {
    if (!merchantIsUpdating) {
      setForm({
        ...data,
        deliveryEstimatedIdUnitTime: Formats.getTimerValue(data.deliveryEstimatedIdUnitTime),
        takeAwayEstimatedIdUnitTime: Formats.getTimerValue(data.takeAwayEstimatedIdUnitTime),
      });
    }
  }, [setForm, data, merchantIsUpdating]);

  const onChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const onSelect = (e, name) => setForm({ ...form, [name]: e });

  const normalizeFormData = () => ({
    ...form,
    deliveryEstimatedIdUnitTime: form.deliveryEstimatedIdUnitTime.value,
    takeAwayEstimatedIdUnitTime: form.takeAwayEstimatedIdUnitTime.value,
  });

  return (
    <Modal
      ariaHideApp={false}
      isOpen={show}
      style={styles.customStyles}
      onRequestClose={onClose}
      parentSelector={() => getParentElement()}
    >
      <styles.Container onSubmit={e => onSave(e, normalizeFormData())}>
        <styles.Title>Tempo para Entrega</styles.Title>

        <styles.Content>
          <styles.Section>
            <styles.SectionHeader>
              <DeliveryIcon size="25px" />
              Delivery
            </styles.SectionHeader>
            <styles.SectionContent>
              <Input
                customStyles={styles.inputCustomStyles}
                onChange={onChange}
                name="deliveryEstimatedTime"
                value={form.deliveryEstimatedTime}
                width="50px"
              />

              <Select
                options={TIMER}
                onChange={e => onSelect(e, 'deliveryEstimatedIdUnitTime')}
                name="deliveryEstimatedIdUnitTime"
                value={form.deliveryEstimatedIdUnitTime}
                customStyles={{ width: '100%' }}
                containerCustomStyles={{ marginLeft: '15px' }}
                closeMenuOnSelect
                isSearchable={false}
              />
            </styles.SectionContent>
          </styles.Section>

          <styles.Section>
            <styles.SectionHeader>
              <TakeawayIcon size="25px" />
              Takeaway
            </styles.SectionHeader>
            <styles.SectionContent>
              <Input
                customStyles={styles.inputCustomStyles}
                onChange={onChange}
                name="takeAwayEstimatedTime"
                value={form.takeAwayEstimatedTime}
                width="50px"
              />

              <Select
                options={TIMER}
                onChange={e => onSelect(e, 'takeAwayEstimatedIdUnitTime')}
                name="takeAwayEstimatedIdUnitTime"
                value={form.takeAwayEstimatedIdUnitTime}
                containerCustomStyles={{ width: '100%', marginLeft: '15px' }}
                closeMenuOnSelect
                isSearchable={false}
              />
            </styles.SectionContent>
          </styles.Section>
        </styles.Content>

        <styles.Footer>
          <Button
            className="back-button"
            type="button"
            secondary
            onClick={onClose}
            customStyles={{ flexShrink: 0 }}
          >
            Voltar
          </Button>
          {error && (
            <styles.ErrorMessage>
              <AlertIcon color="#FFF" size="20px" /> {error}
            </styles.ErrorMessage>
          )}
          <Button className="save-button" type="submit" customStyles={{ flexShrink: 0 }}>
            Salvar
          </Button>
        </styles.Footer>
      </styles.Container>
    </Modal>
  );
};

export default TimeModal;



// WEBPACK FOOTER //
// ./src/components/TimeModal/index.js